// https://github.com/codiini/react-audio-video-recorder/blob/main/src/AudioRecorder.jsx
import { useState, useRef, useEffect } from "react";
import { FaMicrophone, FaPlay, FaAngleLeft, FaCheck, FaPause, FaTrash } from 'react-icons/fa';
import { setValue, getValue, removeItem } from "../db/db";
import { loadCards } from "../store/cards.dispatch";
const mimeType = "audio/webm";

export const VoiceRecorder = ({ cardId, onVoiceUpdate }) => {
  const [permission, setPermission] = useState(false);

  const mediaRecorder = useRef(null);

  const [recordingStatus, setRecordingStatus] = useState("inactive");
  const [hasRecording, setHasRecording] = useState(false);
  const [stream, setStream] = useState(null);
  const [audio, setAudio] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [audioChunks, setAudioChunks] = useState([]);

  const loadAudio = async ({ cardId }) => {
    const audioBlob = await getValue({ key: cardId });
    if (audioBlob) {
      const audioUrl = URL.createObjectURL(audioBlob);
      setAudio(audioUrl);
      setHasRecording(true)
    }
  }
  useEffect(() => {
    loadAudio({ cardId })
  }, [cardId])

  useEffect(() => {
    return async () => {
      await stopRecording();
      loadCards();
    }
  }, [])

  useEffect(() => onVoiceUpdate(hasRecording), [hasRecording, onVoiceUpdate]);

  const getMicrophonePermission = async () => {
    if ("MediaRecorder" in window) {
      try {
        const mediaStream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: false,
        });
        setPermission(true);
        setStream(mediaStream);
      } catch (err) {
        alert(err.message);
      }
    } else {
      alert("We are so, so sorry, but the MediaRecorder API is not supported in your browser.");
    }
  };

  const startRecording = async () => {
    setRecordingStatus("recording");
    setHasRecording(false);
    const media = new MediaRecorder(stream, { type: mimeType });

    mediaRecorder.current = media;

    mediaRecorder.current.start();

    let localAudioChunks = [];

    mediaRecorder.current.ondataavailable = (event) => {
      if (typeof event.data === "undefined") return;
      if (event.data.size === 0) return;
      localAudioChunks.push(event.data);
    };

    setAudioChunks(localAudioChunks);
  };

  const stopRecording = () => {
    setRecordingStatus("inactive");
    setHasRecording(true);

    if (mediaRecorder && (mediaRecorder.current)) {
      mediaRecorder.current.onstop = () => {
        console.log(audioChunks)
        const audioBlob = new Blob(audioChunks, { type: mimeType });
        const audioUrl = URL.createObjectURL(audioBlob);
        setAudio(audioUrl);
        setValue({ key: cardId, value: audioBlob });
        setAudioChunks([]);
      };

      mediaRecorder.current.stop();
    }
  };

  const getStatus = () => permission && recordingStatus;
  const isRecording = () => getStatus() === 'recording';
  const isInactive = () => getStatus() === 'inactive';

  const BtnGetMicrophonePermissions = ({ isVisible }) => (
    isVisible
      ? <button
        onClick={getMicrophonePermission}
        type="button"
        className="p-4 rounded-full border-c1 c1"
      >
        <FaMicrophone />
      </button >
      : null
  )

  const BtnRecord = ({ isVisible, isRecording }) => (
    isVisible ?
      <button
        onClick={
          isRecording
            ? stopRecording
            : startRecording
        }
        type="button"
        className={
          isRecording
            ? "p-4 rounded-full bg-c1 border-c1 c1 heartbeat"
            : "p-4 rounded-full bg-c2 border-c1 c1"
        }
      >
        <FaMicrophone />
      </button>
      : null
  )

  const BtnPlay = ({ hasRecording }) => {
    const baseClass = "p-4 rounded-full bg-c5 c1 ";
    const [isPlaying, setIsPlaying] = useState(false);
    const [className, setClassName] = useState(baseClass);

    return (
      hasRecording
        ? <button
          type="button"
          className={className}
          onClick={() => {
            const elm = document.getElementById('player');

            if (isPlaying) {
              stopRecording();
              setClassName(baseClass);
              elm.pause();
              setIsPlaying(false);
            } else {
              setClassName(baseClass + ' heartbeat');
              elm.currentTime = 0;
              elm.play();
              setIsPlaying(true);
            }
          }}
        >
          {isPlaying ? <FaPause className="heartbeat" /> : <FaPlay />}
        </button>
        : null
    )
  }

  const BtnDeleteAudio = () => {
    return (
      hasRecording
        ? <button
          type="button"
          className="p-4 rounded-full bg-c5 warn"
          onClick={() => {
            const elm = document.getElementById('player');
            elm.pause();
            setIsPlaying(false);
            elm.srcObject = null;
            removeItem({ id: cardId })
            setHasRecording(false);
          }}
        >
          <FaTrash />
        </button>
        : null
    )
  }
  return (
    <div>
      <div className="audio-controls flex justify-center flex-row space-x-2">
        <BtnGetMicrophonePermissions isVisible={!permission} />
        <BtnRecord
          isVisible={permission}
          isRecording={isRecording()}
        />
        <BtnPlay
          isVisible={permission}
          hasRecording={hasRecording}
        />
        <BtnDeleteAudio />
      </div>
      {audio ? (
        <div className="audio-player">
          <audio id="player" src={audio} loop={false}></audio>
        </div>
      ) : null}
    </div>
  );
};